import { actionTypes } from "./account.reducer";

export const setAccountInformation = (data) => {
  return {
    type: actionTypes.SET,
    data,
  };
};
